<div
  class="flex flex-col w-full bg-(--calloutcard-background) gap-(--calloutcard-gap) px-(--calloutcard-padding-x) py-(--calloutcard-padding-y) rounded-(--calloutcard-border-radius)"
  [ngClass]="{ 'border border-solid border-(--calloutcard-border-color)': config().border }"
>
  <div
    class="w-full overflow-hidden shrink-0 relative"
    [ngClass]="{ 'h-[400px]': config().imageUrl }"
  >
    @if (config().imageUrl) {
      <img
        [src]="config().imageUrl"
        alt=""
        class="w-full h-full object-cover object-center rounded-(--calloutcard-border-radius)"
      />
    }
    @if (config().canDismiss) {
      <div class="absolute top-4 right-4">
        <app-dynamic
          componentName="IconButton"
          [props]="{ config: { icon: 'x', size: 'sm', border: config().dismissButtonBorder ?? true } }"
          (action)="onDismiss()"
        />
      </div>
    }
  </div>

  <app-dynamic
    componentName="DynamicText"
    [props]="{ config: titleConfig() }"
  />

  <div class="flex flex-col gap-4 w-full">
    <app-dynamic
      componentName="Button"
      [props]="{ config: primaryButtonConfig() }"
      (action)="onButtonClick($event)"
    />

    @if (secondaryButtonConfig()) {
      <app-dynamic
        componentName="Button"
        [props]="{ config: secondaryButtonConfig() }"
        (action)="onButtonClick($event)"
      />
    }
  </div>
</div>
